<template>
    <div class="user">
      <!--搜索表单-->
      <div class="common-seach-wrap">
        <div class="common-form">筛选历史</div>
        <el-select  v-model="choose_formInline"   @change="click_history">
                    <el-option :label="items.name" :value="items.formInline" v-for="(items,indexs) in history" :key="indexs">
                      <span>{{items.name}}</span>
                    </el-option>
        </el-select>

        <el-button type="primary" size="small"  icon="el-icon-submit" @click="flush">刷新历史条件</el-button>

        <el-button type="primary" size="small"  icon="el-icon-submit"  
          v-if="zd_flag" @click="zd_flag = !zd_flag" style="margin-bottom: 15px;">折叠条件</el-button>

        <el-button type="primary" size="small" style="margin-bottom: 15px;" icon="el-icon-submit"  
          v-if="zd_flag == false" @click="zd_flag = !zd_flag">展开条件</el-button>
       

        <div v-if="zd_flag">
        <div class="common-form">条件筛选</div>
        <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="表名" >
            <el-select v-model="formInline.table_info_id" @change="getTableInfo" >
                <el-option label="不选择" :value="0" >
                      <span>不选择</span>
                </el-option>
                <el-option :label="item.name" :value="item.table_info_id"  v-for="(item,index) in tableList" :key="index">
                      <span>{{item.name}}</span>
                    </el-option>
                </el-select>

          </el-form-item>

          <div v-for="(item,index) in formInline.cond" :key="index">
            <el-form-item label="字段">
              <el-select v-model="item.table_field" v-if="fields" >
                <div class="searchDiv">
                  <el-input
                    placeholder="搜索字段"
                    v-model="searchTxt"
                    @input="searchTxt_in">
                  </el-input>
                </div>
                  <el-option :label="items" :value="items"  v-for="(items,indexs) in fields" :key="indexs">
                    <span >{{ items }}</span>
                    </el-option>
                </el-select>

           </el-form-item>

            <el-form-item label="条件">
                <el-select v-model="item.conds_val"   >
                    <el-option :label="items.val" :value="items.code" v-for="(items,indexs) in conds" :key="indexs">
                      <span>{{items.val}}</span>
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="值" v-if="item.conds_val != 'regular_phone'">
                <el-input size="small" style="width: 600px;" :rows="2" type="textarea" v-model="item.table_value" placeholder="请输入值（逗号隔开）"></el-input>
            </el-form-item>


            <el-button type="primary" size="small" v-if="index == 0" icon="el-icon-submit" @click="addCond(item.id)" >添加条件</el-button>
            <el-button type="primary" style="background: rgb(236, 77, 77);border: 1px solid rgb(236, 77, 77);"  size="small" v-if="index != 0" icon="el-icon-submit" @click="delCond(item.id)" >删除条件</el-button>
          </div>


          <div class="common-form">记录筛选历史</div>
          <el-form-item label="记录筛选历史">
            <el-input size="small" style="width: 300px;" type="text" v-model="formInline.record" placeholder="请输入名称(不填写则不记录)"></el-input>
            <el-input size="small" style="width: 300px;" type="text" v-model="formInline.remark" placeholder="筛选历史描述"></el-input>

          </el-form-item>
        </el-form>
  
    </div>
    <div style="margin-bottom: 20px;">

      <el-button type="primary" icon="el-icon-submit" @click="getTableResult(1)" v-auth="'/plus/password/query'">筛选</el-button>
            <!-- <el-button type="primary" style="background: rgb(232, 163, 89);border: 1px solid rgb(232, 163, 89);" 
            icon="el-icon-submit" @click="sync" >一键同步数据</el-button> -->
            <el-button type="primary" icon="el-icon-submit" @click="syncLabel" >数据打标签</el-button>
            <el-button type="primary" style="background: rgb(232, 163, 89);border: 1px solid rgb(232, 163, 89);" 
            icon="el-icon-submit" @click="exportData" >全部导出</el-button>
            <el-button type="primary"
            icon="el-icon-submit" @click="systemReScoring" >系统打分</el-button>

            <el-button type="primary" style="background: rgb(232, 163, 89);border: 1px solid rgb(232, 163, 89);" 
            icon="el-icon-submit" @click="openSendSms" >短信群发</el-button>
            <el-button type="primary"  
            icon="el-icon-submit" @click="delData" >删除数据</el-button>

            <el-button type="primary"  
            icon="el-icon-submit" style="background: rgb(232, 163, 89);border: 1px solid rgb(232, 163, 89);" 
             @click="updContent" >更新网页数据</el-button>
    </div>
    

      <!--内容-->
      <div class="product-content" v-if="fieldColumn.length > 0">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" >

          <el-table-column v-for="items in fieldColumn" :key="items.index" :label="items">
            <template slot-scope="scope">
              <div style="text-overflow: -o-ellipsis-lastline;
	            overflow: hidden;
	            text-overflow: ellipsis;
	            display: -webkit-box;
	          -webkit-line-clamp: 2;
	          line-clamp: 2;
	          -webkit-box-orient: vertical;	">

            <span v-if="items == 'url'">
              <a @click="a_click(getDataName(scope.row,items))" >{{ getDataName(scope.row,items) }}</a>
            </span>


            <!-- 总分 -->
            <span v-if="items == 'sumBounds' " style="font-weight: 600;">
              {{ getDataName(scope.row,items)>0?getDataName(scope.row,items): getDataName(scope.row,items)}}
            </span>
            <!-- 系统加分 -->
            <span v-if="items == 'system_bonus' " style="color:rgb(87, 87, 237);">
              {{ getDataName(scope.row,items)>0?"+"+getDataName(scope.row,items): getDataName(scope.row,items)}}
            </span>
            <!-- 关键词统计 -->
            <span v-if="items == 'keywords' " >
           <a @click="keywords_click(true, getDataName(scope.row,items))">{{getDataName(scope.row,items)}} </a>
            </span>
            <!-- 人工加分 -->
            <span v-if="items =='artificial_bonus'" style="color:rgb(87, 87, 237);">

              <span v-if="choose_artificial_bonus_id == 0" @click="artificial(scope.row,'bonus')">
                 {{ getDataName(scope.row,items)>0?"+"+getDataName(scope.row,items): getDataName(scope.row,items)}}</span>
              <el-input  @blur="choose_artificial_blur('bonus')" v-if="choose_artificial_bonus_id == scope.row.data_content_id"
              v-model="artificial_bonus"></el-input>
            </span>

           <!-- 系统减分 -->
            <span v-if="items == 'system_deduction'" style="color:red;">
              {{ getDataName(scope.row,items)>0?"-"+getDataName(scope.row,items): getDataName(scope.row,items)}}
            </span>
            <!-- 人工减分 -->
            <span v-if=" items =='artificial_deduction'" style="color:red;">
              <span v-if="choose_artificial_deduction_id == 0" @click="artificial(scope.row,'deduction')">
               {{ getDataName(scope.row,items)>0?"-"+getDataName(scope.row,items):
              getDataName(scope.row,items)}}</span>
              <el-input  @blur="choose_artificial_blur('deduction')"
              v-if="choose_artificial_deduction_id == scope.row.data_content_id"  v-model="artificial_deduction"></el-input>
            </span>
            <span v-if="items != 'url' && items != 'system_deduction' && items !='artificial_deduction' &&
            items != 'system_bonus' && items !='artificial_bonus' && items !='sumBounds'  && items !='keywords' ">
              {{ getDataName(scope.row,items) }}
            </span>

          </div>
            </template>
          </el-table-column>


          </el-table>
        </div>

        <!--分页-->
        <div class="pagination">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
            :page-sizes="[20, 50, 100, 200, 300, 500]"
            :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="totalDataNumber">
          </el-pagination>
        </div>
      </div>
</div>

      <el-dialog :title="task.totalTime!=''?('预计'+task.totalTime+'后完成'):('请稍等...')" :visible.sync="task.loadDialogStatus" :close-on-click-modal="false"
      :close-on-press-escape="false" :show-close="false" width="20%">
        <div style="text-align: center;">
          <el-progress type="circle" :percentage="task.percentage"></el-progress>
        </div>
        <div slot="footer"  style=" margin: auto;text-align: center;">
          <el-button type="primary" style="margin: auto;text-align: center;" @click="downClose">取消</el-button>
        </div>
    </el-dialog>



    <el-dialog :visible.sync="keywords_flag"  @close="keywords_click(false,'')"
      :close-on-press-escape="false" :show-close="false" width="20%">
      <div style="text-align: center;">
       <div v-html="keywords"></div>
      </div>

    </el-dialog>

    <!-- 短信群发 -->
    <el-dialog :visible.sync="sms_flag"  @close="sms_click(false,'')"
      :close-on-press-escape="false" :show-close="false" width="40%">
      <div >
        
        <div>当前筛选后的数量：{{ totalDataNumber }}条</div>
        <el-select  v-model="formInline.smsTaskId"   style="margin-top: 20px;">
          <el-option label="不选择任务" :value="0" >
                 
                    </el-option>
                    <el-option :label="items.name" :value="items.sms_task_id" v-for="(items,indexs) in smsTask" :key="indexs">
                      <span>{{items.name}}</span>
                    </el-option>
        </el-select>
        <div style="margin-top: 20px;其中字段【send_sms_num】代表发送带短信的次数，可用条件筛选掉已经发送过短信的数据">
          说明：群发短信之前先筛选出你想要发送短信的数据
        </div>

        <div slot="footer"  style=" margin: auto;text-align: right;">
          <el-button type="primary" style="margin: auto;text-align: center;" @click="sendSms">发送</el-button>
        </div>
      </div>

    </el-dialog>

    </div>
  </template>

  <script>
    import AnalysisApi from '@/api/analysis.js';
    import SmsApi from '@/api/sms.js';
    import utils from '@/utils/utils'
    import axios from 'axios'
    var CancelToken = axios.CancelToken;//用于中断任务
    export default {
      components: {

    },
      data() {
        return {
          zd_flag:false,
          /*是否加载完成*/
          loading: false,
          /*列表数据*/
          tableData: [],
          /*一页多少条*/
          pageSize: 20,
          /*一共多少条数据*/
          totalDataNumber: 0,
          /*当前是第几页*/
          curPage: 1,
          /*横向表单数据模型*/
          choose_formInline:{

          },
          formInline: {
  
            table_info_id:"",//表名ID
            table_field:"",//选择字段
            cond:[{
              "id":0,
              "table_field":"is_delete",
              "conds_val":"equality",
              "table_value":"0",
            }],
            table_value:"",
            
            record:"",//筛选历史标题
            remark:"",//筛选历史描述

            smsTaskId:0,//选择的短信发送任务

          },
          dataModel:[],
          codes:[],//类型
          password_id:"",//修改的ID
          conds:[],//筛选值
          fields:[],//表字段
          tableList:[],//表数组
          searchTxt:'',
          fieldColumn:[],
          history:[],
          task: {
            loadDialogStatus: false, //弹出框控制的状态
            percentage: 0, //进度条的百分比
            source: {}, //取消下载时的资源对象
            process_code:"",//任务编号
            totalTime:''
          },
          artificial_bonus:0,//人工加分
          artificial_deduction:0,//人工减分
          choose_artificial_deduction_id:0,
          choose_artificial_bonus_id:0,

          keywords_flag:false,
          keywords:"",

          sms_flag:false,
          
          smsTask:[]


          
        };

      },
      created() {
        /*获取表列表*/
        this.getTableList();
        //获取筛选历史
        this.getDataHistory()
   
      },

      methods: {
        sendSms(){//发送短信任务
          var self =this;
          if(self.formInline.smsTaskId == 0){
            self.$message.error('请选择发送任务');
            return;
          }
          self.sms_flag = false;
          // //开启任务监听
          if(self.task.process_code == ""){
            self.task.process_code =  utils.createordernum()
            self.task.loadDialogStatus = true;
            self.loading = true;
            utils.monitorTask(self.task.percentage,function(resu,percentage,timer,totalTime){
              console.log("timer",timer)
              self.timer = timer;//记录定时器
              if(resu == -1){
                self.canelTask(self,true,function(){
                    self.getTableResult(1)
                })
              }else if(resu == 1){
                self.task.percentage = percentage
                self.task.totalTime = totalTime
              }
              
            },self.task.process_code);
          }
          if(self.task.process_code != ""){
              //执行分批任务
              self.formInline.page = self.curPage;
              self.formInline.list_rows = self.pageSize;
              self.task.source = CancelToken.source();
              utils.reqTask(self,axios,self.task.source.token,self.task.percentage,self.task.process_code,
              self.formInline,AnalysisApi,function(resu,resu2){
                if(resu == 1){//完成中断调用
                  self.canelTask(self,true,function(){
                    self.getTableResult(1)
                  })
                }else if(resu == -2){//重新调用
                  self.task.process_code = resu2
                  self.sendSms()
                }else{
                  self.canelTask(self,true,function(){
                      self.getTableResult(1)
                  })
                  setTimeout(() => {
                     clearInterval(self.timer)
                  }, 4000);
                  
                }
              },"sendSms",self.formInline.smsTaskId)
            }
          

        },
        getSmsTask(){//获取短信任务
          var self = this;
          SmsApi.taskList({
            "code":"select"
          }, ).then(data => {
            self.smsTask = data.data.list
          })
          .catch(error => {
            this.file_id = "";
            self.$message.error('修改失败');

          });
        },
        updContent(){//删除数据
          var self = this;
          //开启任务监听
          if(self.task.process_code == ""){
            self.task.process_code =  utils.createordernum()
            self.task.loadDialogStatus = true;
            self.loading = true;
            utils.monitorTask(self.task.percentage,function(resu,percentage,timer,totalTime){
              if(resu == -1){
                self.canelTask(self,true,function(){
                    self.getTableResult(1)
                })
              }else if(resu == 1){
                self.task.percentage = percentage
                self.task.totalTime = totalTime
              }
              self.timer = timer;//记录定时器
            },self.task.process_code);
          }
          if(self.task.process_code != ""){
            //执行分批任务
            self.formInline.page = self.curPage;
            self.formInline.list_rows = self.pageSize;
            self.task.source = CancelToken.source();
            utils.reqTask(self,axios,self.task.source.token,self.task.percentage,self.task.process_code,self.formInline,AnalysisApi,function(resu,resu2){
              if(resu == 1){//完成中断调用
                self.canelTask(self,true,function(){
                  self.getTableResult(1)
                })
              }else if(resu == -2){//重新调用
                self.task.process_code = resu2
                self.updContent()
              }else{
                self.canelTask(self,true,function(){
                  self.getTableResult(1)
                })
              }
            },"updContent")
          }
        },
        delData(){//删除数据
          var self = this;
          //开启任务监听
          if(self.task.process_code == ""){
            self.task.process_code =  utils.createordernum()
            self.task.loadDialogStatus = true;
            self.loading = true;
            utils.monitorTask(self.task.percentage,function(resu,percentage,timer,totalTime){
              if(resu == -1){
                self.canelTask(self,true,function(){
                    self.getTableResult(1)
                })
              }else if(resu == 1){
                self.task.percentage = percentage
                self.task.totalTime = totalTime
              }
              self.timer = timer;//记录定时器
            },self.task.process_code);
          }
          if(self.task.process_code != ""){
            //执行分批任务
            self.formInline.page = self.curPage;
            self.formInline.list_rows = self.pageSize;
            self.task.source = CancelToken.source();
            utils.reqTask(self,axios,self.task.source.token,self.task.percentage,self.task.process_code,self.formInline,AnalysisApi,function(resu,resu2){
              if(resu == 1){//完成中断调用
                self.canelTask(self,true,function(){
                  self.getTableResult(1)
                })
              }else if(resu == -2){//重新调用
                self.task.process_code = resu2
                self.delData()
              }else{
                self.canelTask(self,true,function(){
                  self.getTableResult(1)
                })
              }
            },"delData")
          }
        },


        openSendSms(){//开启短信群发窗口
               //获取短信任务
          this.getSmsTask();
          this.sms_flag = true;
        },


        keywords_click(keywords_flag,keywords){//显示关键词
          var self = this;
          self.keywords = keywords
          self.keywords_flag = keywords_flag;
        },
        sms_click(){//关掉短信群发接口
          this.sms_flag = false
        },
        choose_artificial_blur(code){
            //人工加分/减分
        let self = this;
        var score = 0;
        var choose_artificial_id = 0;
        if(code == "bonus"){
            if(self.artificial_bonus < 0){
              self.$message({
                type: 'error',
                message: '分数不能小于0哦'
              });
            return;
          }
          score = self.artificial_bonus
          choose_artificial_id = self.choose_artificial_bonus_id

        }else{
            if(self.artificial_deduction < 0){
              self.$message({
                type: 'error',
                message: '分数不能小于0哦'
              });
              return;
          }
          score = self.artificial_deduction
          choose_artificial_id = self.choose_artificial_deduction_id
        }
        for(var i=0;i<self.tableData.length;i++){
          var el = self.tableData[i];
          if(el.data_content_id == choose_artificial_id){
            if(code == "bonus"){
              self.tableData[i].artificial_bonus = score
            }else{
              self.tableData[i].artificial_deduction = score
            }
           }
      }
        AnalysisApi.artificialScoring({
            "code":code,
              "score":score,
              "data_content_id":choose_artificial_id
          }, ).then(data => {
            self.choose_artificial_deduction_id = 0;
            self.choose_artificial_bonus_id = 0;
            self.$message({
                    type: 'success',
                    message: '人工打分成功'
                  });


          })
          .catch(error => {
            this.file_id = "";
            self.$message.error('修改失败');

          });
        },
        artificial(item,code){
          var self = this;

          if(code == "bonus"){
            self.artificial_bonus = item.artificial_bonus
            self.choose_artificial_bonus_id = item.data_content_id;
          }else{
            self.artificial_deduction = item.artificial_deduction
            self.choose_artificial_deduction_id = item.data_content_id;
          }
        },

        systemReScoring(){//自动打分-分批执行
          var self = this;
          //开启任务监听
          if(self.task.process_code == ""){
            self.task.process_code =  utils.createordernum()
            self.task.loadDialogStatus = true;
            self.loading = true;
            utils.monitorTask(self.task.percentage,function(resu,percentage,timer,totalTime){
              if(resu == -1){
                self.canelTask(self,true,function(){
                    self.getTableResult(1)
                })
              }else if(resu == 1){
                self.task.percentage = percentage
                self.task.totalTime = totalTime
              }
              self.timer = timer;//记录定时器
            },self.task.process_code);
          }
          if(self.task.process_code != ""){
            //执行分批任务
            self.formInline.page = self.curPage;
            self.formInline.list_rows = self.pageSize;
            self.task.source = CancelToken.source();
            utils.reqTask(self,axios,self.task.source.token,self.task.percentage,self.task.process_code,self.formInline,AnalysisApi,function(resu,resu2){
              if(resu == 1){//完成中断调用
                self.canelTask(self,true,function(){
                  self.getTableResult(1)
                })
              }else if(resu == -2){//重新调用
                self.task.process_code = resu2
                self.systemReScoring()
              }else{
                self.canelTask(self,true,function(){
                  self.getTableResult(1)
                })
              }
            },"systemReScoring")
          }
          // var self = this;
          // //开启任务监听
          // if(self.task.process_code == ""){
          //   self.task.process_code =  utils.createordernum()
          //   self.task.loadDialogStatus = true;
          //   self.loading = true;
          //   utils.monitorTask(self.task.percentage,function(resu,percentage,timer){
          //     if(resu == -1){
          //       self.canelTask(self,true,function(){
          //           self.getTableResult(1)
          //       })
          //     }else if(resu == 1){
          //       self.task.percentage = percentage
          //     }
          //     self.timer = timer;//记录定时器
          //   },self.task.process_code);
          // }
          // if(self.task.process_code != ""){
          //   //执行分批任务
          //   self.formInline.page = self.curPage;
          //   self.formInline.list_rows = self.pageSize;
          //   self.task.source = CancelToken.source();
          //   utils.reqTask(self,axios,self.task.source.token,self.task.percentage,self.task.process_code,self.formInline,AnalysisApi,function(resu,resu2){
          //     if(resu == 1){//完成中断调用
          //       self.canelTask(self,true,function(){
          //         self.getTableResult(1)
          //       })
          //     }else if(resu == -2){//重新调用
          //       self.task.process_code = resu2
          //       self.systemReScoring()
          //     }
          //   },"systemReScoring")
          // }
        },
        exportData(){
          var self = this;

          let baseUrl = window.location.protocol + '//' + window.location.host;
                  window.open(baseUrl + '/index.php/shop/plus.data.analysis/exportData?formInline='+ JSON.stringify(self.formInline))
                  return;
          self.formInline.page = self.curPage;
          if(self.task.process_code == ""){
            self.task.process_code =  createordernum()
            self.setInterval_timer();
            self.task.loadDialogStatus = true;
            self.loading = true;
          }

          self.formInline.list_rows = self.pageSize;
            AnalysisApi.analysysExportData({
              formInline:JSON.stringify(self.formInline),
              process_code: self.task.process_code,
            }).then(data => {
              console.log(data.data)
              if(data.data.status == 1){
                  self.task.percentage = 0;
                  self.task.loadDialogStatus = false;
                  clearInterval(self.timer);
                  self.getTableResult(1);
                  let baseUrl = window.location.protocol + '//' + window.location.host;
                  window.open(baseUrl + '/index.php/shop/plus.data.analysis/exportData?process_code='+ self.task.process_code)
                  
                  return ;
              }else if(data.data.status == -2){//中断方法重新调用  保证一个连接不超时
                console.log("self.task.percentage",self.task.percentage)  
                if(self.task.percentage > 0 && self.task.percentage < 100){
                    self.exportData()
                  }
                  self.task.process_code = data.data.val
              }
             
            }).catch(error => {
              clearInterval(self.timer);
              self.task.percentage = 0;
          });
         
        },
    downClose() {//取消下载事件
      var self = this;
      self.task.source.cancel('任务已取消');
    },
    canelTask(self,flag,callback){//集中取消事件
      console.log("self.timer",self.timer)
      if(flag){//如果完全停止循环  则为true
        clearInterval(self.timer)
        self.task.process_code = "";
        setTimeout(function(){
          self.task.percentage = 0;
          self.task.totalTime = 0
          self.task.loadDialogStatus = false;
          callback();
        },2000)
        
      }

    },
        flush(){//刷新筛选历史
          this.getDataHistory()
        },
        click_history(){//选择筛选历史
          var self = this;
          self.formInline =JSON.parse(self.choose_formInline)
          self.getTableResult(1)

        },
        a_click(url){
          var str=new RegExp("http");
          var val = str.test(url);//test方法返回值为(true或者false)
          if(val){
            window.open(url)
          }else{
            window.open("http://"+url)
          }

        },
        getDataHistory(){
          var self = this;
          self.loading = true;
            AnalysisApi.getDataHistory({

            }).then(data => {
              self.history = data.data
              self.choose_formInline = data.data[0].formInline;
              self.formInline = JSON.parse(data.data[0].formInline)
              self.getTableInfo(self.formInline.table_info_id)
              self.getTableResult(1)
            }).catch(error => {
          });
        },
       
        getTableResult(curPage){//获取分析结果
          var self = this;
          self.curPage = curPage;
          self.formInline.page = curPage;
          self.formInline.list_rows = self.pageSize;
          console.log("self.formInline",self.formInline)
          const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
            AnalysisApi.getTableResult({
              formInline:JSON.stringify(self.formInline)
            }).then(data => {
              self.fieldColumn = data.data.fieldColumn;
              self.loading = false;
              loading.close();
              self.tableData = data.data.list.data;
              self.totalDataNumber = data.data.list.total
            }).catch(error => {
          });
        },
        syncLabel(){//给数据打上标签
          AnalysisApi.syncLabel({

          }).then(data => {
            this.$message({
              type: 'success',
              message: '打标签成功'
            });
          }).catch(error => {
        });
        },
        syncPhone(){//抓取手机号
          AnalysisApi.syncPhone({

          }).then(data => {
            this.$message({
              type: 'success',
              message: '抓取成功'
            });
          }).catch(error => {
        });
        },
        searchTxt_in(val){//搜索字段
          console.log(val)
          this.fields.map((item,index) => {
          if(item == val){
            this.fields.unshift(this.fields.splice(index , 1)[0]);
          }
        })
        },
        getDataName(scope,items){
          return scope[items]
        },
        getTableInfo(table_info_id){//获取表字段
          var self = this;
          console.log(table_info_id)
          AnalysisApi.getTableInfo({
            table_info_id:table_info_id
          }).then(data => {
            console.log(data.data)
            self.fields = data.data;
          }).catch(error => {
        });
        },
        addCond(id){//添加条件
          this.formInline.cond.push(
            {
              "id": this.formInline.cond[ this.formInline.cond.length-1].id +1,
              "table_field":"",
              "conds_val":"",
              "table_value":"",
            }
          );
        },
        delCond(id){//删除条件
          this.formInline.cond =  this.formInline.cond.filter(function(item) {
            return item.id !== id
          });
        },
        sync(){//一键同步数据

        },
        /*选择第几页*/
        handleCurrentChange(val) {
          let self = this;
          self.curPage = val;
          self.loading = true;
          self.getTableResult(self.curPage);
        },

        /*每页多少条*/
        handleSizeChange(val) {
          this.curPage = 1;
          this.pageSize = val;
          self.getTableResult(this.curPage);
        },

        /*获取列表*/
        getTableList() {
          let self = this;
          AnalysisApi.getTableList().then(data => {
            console.log(data)
            self.tableList = data.data.list;
            self.conds = data.data.condition;
          }).catch(error => {

          });
        },

      }
    };






  </script>
  <style></style>



// WEBPACK FOOTER //
// src/views/plus/data/analysis/index/index.vue